import React from 'react'
// import i18n from '@pureartisan/simple-i18n'
import { makeStyles } from '@material-ui/core/styles'
import {
  Box,
  Typography,
  Tooltip as MuiTooltip,
} from '@material-ui/core'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import clsx from 'clsx'
import useStore from '../store'
import shallow from 'zustand/shallow'
// import { HelpCircleIcon } from '../../../assets/Icons'

// Styles for component.
const useStyles = makeStyles(theme => ({
  root: {},
  helpIcon: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    margin: theme.spacing(0, 0.5),
    verticalAlign: 'middle',
    fill: theme.extras.variables.colors.textSubtle,
  },
  tooltip: {
    color: theme.extras.variables.colors.white,
    '& .fake-link': {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  },
}))

const Tooltip = ({
  children,
  title,
  interactive = true,
  // wrapping in div can impact layout, but not wrapping can interfere with hover events (eg for icons)
  unwrappedChildren,
  ...props
}) => {
  if (!title && title !== 0) return null
  const classes = useStyles()
  const { setStoreValues } = useStore(
    state => ({
      setStoreValues: state.setStoreValues,
    }),
    shallow,
  )

  const handleFakeLinkClick = e => {
    if (
      e.target.classList.contains('fake-link') &&
      !!e.target.dataset.faq
    ) {
      const faqId = e.target.dataset.faq
      setStoreValues({
        slideoutPanel: {
          active: true,
          panel: 'faq',
        },
        expandedFaqs: { [faqId]: true },
      })

      setTimeout(() => {
        // scroll to question, whether in modal or slideout panel
        const elem = document.querySelector(`#faq-${faqId}`)
        elem && elem.scrollIntoView({ behavior: 'smooth' })
      })
    }
  }

  return (
    <MuiTooltip
      enterTouchDelay={0} // so they appear immediately on mobile touch
      className={classes.root}
      interactive={interactive}
      {...props}
      title={
        <Typography
          onClick={handleFakeLinkClick}
          variant="body1"
          className={classes.tooltip}
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        ></Typography>
      }
      arrow
    >
      {children ? (
        unwrappedChildren ? (
          children
        ) : (
          <Box className={clsx('tooltip-children-wrapper')}>
            {children}
          </Box>
        )
      ) : (
        <HelpOutlineIcon className={classes.helpIcon} />
      )}
    </MuiTooltip>
  )
}

Tooltip.propTypes = {}

Tooltip.defaultProps = {}

export default Tooltip
